import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';

export interface IMedia extends IMongoWorkspace {
    fieldname: string;
    originalname: string;
    encoding: string;
    mimetype: string;
    destination: string;
    filename: string;
    path: string;
    size: number;
}
